// 简体中文语言包
export default {
  // 通用
  common: {
    learnMore: '了解更多',
    viewDetails: '了解详情',
    backToTop: '返回顶部',
    loading: '加载中...',
    confirmSubmit: '确认提交',
    backToHome: '返回首页',
    backToPrevious: '返回上页',
    category: '分类',
    all: '全部',
    wechatQrcode: '微信公众号',
    emailAddress: '邮箱地址',
    copySuccess: '复制成功',
    copy: '复制',
    noData: '暂无数据',
    noDataDesc: '该分类下暂时没有相关内容',
  },

  // 语言
  language: {
    zhCN: '简体中文',
    en: 'English',
    ja: '日本語',
    es: 'Español',
    fr: 'Français',
    selectLanguage: '选择语言',
  },

  // 导航菜单
  nav: {
    home: '首页',
    aboutUs: '关于我们',
    companyIntro: '企业介绍',
    awardsHonors: '获奖与称号',
    products: '产品中心',
    coronaryBypass: '冠脉搭桥',
    severeHeartDisease: '重症心脏病及体外循环',
    vascularIntervention: '血管介入',
    academic: '学术资讯',
    newProducts: '新品发布',
    clinicalRelated: '临床相关',
    academicFrontier: '学术前沿',
    news: '企业动态',
    newsExpress: '新闻速递',
    awards: '获奖情况',
    financingAnnouncement: '融资公告',
    contactUs: '联系我们',
  },

  // 首页
  home: {
    // Banner
    bannerSlogan: '悦唯所至 繁复皆简',
    bannerSloganHighlight: '简',

    // 产品解决方案
    productSolutions: '产品解决方案',
    productCenter: '产品中心',
    coronaryBypass: '冠脉搭桥',
    severeHeartDisease: '重症心脏病',
    severeHeartDiseaseAndECMO: '重症心脏病及体外循环',
    severeHeartDiseaseMobile: '重症心脏病<br>及体外循环',
    vascularIntervention: '血管介入',

    // 我们的愿景
    ourVision: '我们的愿景',
    aboutUs: '关于我们',
    visionTitle1: '创新',
    visionText1: '源于临床需求',
    visionTitle2: '匠心',
    visionText2: '成就健康未来',

    // 发展历程
    developmentHistory: '发展历程',
    timeline: {
      year2021: '悦唯医疗成立于北京',
      year2023_1: '中关村高新技术企业',
      year2023_2: '国家级高新技术企业',
      year2023_3: '科技部科技型中小企业',
      year2024_1: '北京市专精特新中小企业',
      year2024_2: '博鳌企业论坛年度(行业)领军企业',
      year2024_3: '北京基金协会<未来可持续投资2024年优秀案例>',
    },

    // 企业动态
    newsCenter: '新闻中心',
    enterpriseDynamics: '企业动态',
    corporateHonors: '企业荣誉',
    capitalDynamics: '资本动态',
    strategicCooperation: '战略合作',
    newsTitle: '悦唯医疗获近亿元A++轮投资 加速重症冠心病诊疗全流程',
    newsCategory: '融资公告',
    newsDate: '2025/12/07',
    newsDesc: '发布公司发展、合作项目及重要对外信息',

    // 学术资讯
    academicInfo: '学术资讯',
    clinicalResearch: '临床研究',
    literatureInterpretation: '文献解读',
    academicPromotion: '学术推广',
    academicTitle1: '新品发布',
    academicTitle2: '临床相关',
    academicTitle3: '学术前沿',
    academicDesc1: '重新定义速度与精准｜悦唯全新心脏稳定器重磅发布',
    academicDesc2: 'AI驱动赋能冠心病精准诊疗展望2026全新启航',
    academicDesc3: '洞见全球临床新视角第十二届ICEF在北京隆重召开',
    academicDetailText: '聚焦产品相关临床研究、学术证据及学术交流内容',
  },

  // 关于我们页面
  about: {
    aboutYuewei: '关于悦唯',
    mission: '使命',
    missionText1: '成为心血管外科领域',
    missionText2: '备受信赖的伙伴',
    vision: '愿景',
    visionText1: '创新',
    visionText2: '源于临床需求',
    visionText3: '匠心',
    visionText4: '成就健康未来',
    values: '价值观',
    valuesText1: '通过持续创新',
    valuesText2: '赋能外科医生，普及先进术式',
    valuesText3: '为更多患者',
    valuesText4: '开启生命新希望',
    awardsAndTitles: '获奖与称号',
    companyIntro: '悦唯医疗成立于2021年9月，由安贞医院心脏外科医生联合国内外头部医疗器械企业高管创立，是一家专注于心血管外科医疗器械研发、生产、销售的高新技术企业。公司目前已获得国家级高新技术企业，北京市"专精特新"中小企业等荣誉称号。',
    productIntro: '目前主要产品分为三大板块：',
    productLine1Title: '冠心病外科板块',
    productLine1Desc: '，以冠脉血管流量计，新一代心脏稳定器为核心，布局近十款手术器械，做到了冠脉外科高值耗材全覆盖；',
    productLine2Title: '重症心脏病及体外循环板块',
    productLine2Desc: '，以悦唯自主研发的高端插管工艺及材料为核心，布局薄壁股动静脉插管、双腔静脉插管等多款国内首创产品；',
    productLine3Title: '深静脉血栓治疗板块',
    productLine3Desc: '，该板块是公司自2024年开始，以并购方式进行的战略性布局，围绕深静脉血栓治疗，布局两款创新医疗器械。',
    companyMotto: '悦唯医疗自成立以来，始终秉持"创新源于临床需求，匠心成就健康未来"的发展理念，致力于成为中国重症心血管外科手术器械的领导者。',
  },

  // 获奖与称号页面
  prize: {
    title: '获奖与称号',
    aboutYuewei: '关于悦唯',
    viewDetails: '查看详情',
    awards: {
      award1: {
        year: '2023',
        title: '中关村高新技术企业',
      },
      award2: {
        year: '2023',
        title: '国家级高新技术企业',
      },
      award3: {
        year: '2023',
        title: '科技部科技型中小企业',
      },
      award4: {
        year: '2024',
        title: '北京市专精特新中小企业',
      },
      award5: {
        year: '2024',
        title: '博鳌企业论坛年度(行业)领军企业',
      },
      award6: {
        year: '2024',
        title: '北京基金协会',
        subtitle: '<未来可持续投资2024年优秀案例>',
      },
    },
  },

  // 产品中心页面
  products: {
    productDetails: '产品详情',
    productCenter: '产品中心',
    categories: {
      coronaryBypass: '冠脉搭桥',
      severeHeartDisease: '重症心脏病及体外循环',
      vascularIntervention: '血管介入',
    },
    items: {
      heartStabilizer: {
        name: '心脏稳定器',
        code: '【注册证号】京械注准20242030034',
      },
      coronaryImaging: {
        name: '冠脉造影影像处理软件',
        code: '【注册证号】京械注准20242210076',
      },
      endoscopeVessel: {
        name: '内窥镜血管采集系统*',
        code: '*该产品尚未在中国上市',
      },
      proximalAnastomosis: {
        name: '近端吻合辅助系统**',
        code: '*该产品尚未在中国上市',
      },
      ultrasonicFlowmeter: {
        name: '超声血管流量计(TTFM+ECUS)*',
        code: '*该产品尚未在中国上市',
      },
    },
  },

  // 产品详情页面
  productDetail: {
    productCenter: '产品中心',
    title: '心脏稳定器',
    subtitle: '模块化、多功能心脏稳定器',
    code: '【注册证号】京械注准20242030034',
    description: '这里是产品介绍的富文本内容，后台维护的。这里是产品介绍的富文本内容，后台维护的。这里是产品介绍的富文本内容，后台维护的。这里是产品介绍的富文本内容，后台维护的。这里是产品介绍的富文本内容，后台维护的。这里是产品介绍的富文本内容，后台维护的。这里是产品介绍的富文本内容，后台维护的。这里是产品介绍的富文本内容，后台维护的。这里是产品介绍的富文本内容，后台维护的。这里是产品介绍的富文本内容，后台维护的。这里是产品介绍的富文本内容，后台维护的。这里是产品介绍的富文本内容，后台维护的。这里是产品介绍的富文本内容，后台维护的。这里是产品介绍的富文本内容，后台维护的。这里是产品介绍的富文本内容，后台维护的。这里是产品介绍的富文本内容，后台维护的。这里是产品介绍的富文本内容，后台维护的。这里是产品介绍的富文本内容，后台维护的。',
  },

  // 联系我们页面
  contact: {
    title: '联系我们',
    yourName: '姓名',
    enterYourName: '请输入姓名',
    yourPhone: '电话',
    enterYourPhone: '请输入电话',
    yourCompany: '公司',
    enterYourCompany: '请输入公司',
    yourMessage: '留言',
    enterYourMessage: '请输入留言',
    privacyAgreement: '我同意悦唯医疗处理我的个人数据，我申明我已阅读隐私政策所包含的内容',
    submitSuccess: '提交成功',
    validation: {
      nameRequired: '请输入姓名',
      phoneRequired: '请输入电话',
      companyRequired: '请输入公司',
      messageRequired: '请输入留言',
      agreeRequired: '请同意隐私政策',
    },
    companyName: '北京悦唯医疗科技有限责任公司',
    address: '北京市大兴区经济开发区科苑路18号华商创意中心',
  },

  // 企业动态页面
  news: {
    title: '新闻公告',
    categories: {
      all: '全部',
      newsExpress: '新闻速递',
      awards: '获奖情况',
      financing: '融资公告',
    },
  },

  // 学术资讯页面
  academic: {
    title: '医疗创新',
    categories: {
      all: '全部',
      newProducts: '新品发布',
      clinical: '临床相关',
      frontier: '学术前沿',
    },
  },

  // 页脚
  footer: {
    companyName: '北京悦唯医疗科技有限责任公司',
    companyNameEn: 'Beijing Yuewei Medical Technology Co., Ltd',
    address: '公司地址：北京市大兴区经济开发区科苑路18号华商创意中心',
    addressShort: '地址：北京市大兴区经济开发区科苑路18号华商创意中心',
    copyright: 'Copyright © 2025 北京悦唯医疗科技有限责任公司',
    icp: 'ICP备案：',
    icpNumber: '京ICP备2025155672号-1',
    securityNumber: '京公网安备11011502039384号',
    medicalLicense: '药品医疗器械网络信息服务备案编号：',
    medicalLicenseNumber: '(京)网药械信息备字（ 2024）第 00322 号',
  },
}
